import { useNavigate, useParams } from "react-router-dom";
import { Body, ContainerInputs, NovoUsuarioContainer } from "./styles";
import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import voltar from "../../../../assets/voltar.svg";
import { toast } from "react-toastify";
import api from "../../../../services/api";
import { ReactSVG } from "react-svg";
import Loading from "../../../Loading";
import Table from "./Table";
import Criativo from "../../../../assets/criativo.svg"
import { yupResolver } from "@hookform/resolvers/yup";
import { EditarCriativoSchema } from "../../../../schemas/campanha";
import { ModalFinalizarCriativo } from "../../../Modal/FinalizarCriativo";
import { useAuth } from "../../../../providers/Auth";
import { ModalReabrirCriativo } from "../../../Modal/ReabrirCriativo";
import Historico from "../../../../assets/historico.svg"

const EditarCriativo = () => {
  const { user } = useAuth()
  const { id } = useParams();
  const { register, getValues, handleSubmit, reset, formState: { errors }, setValue } = useForm({
    resolver: yupResolver(EditarCriativoSchema),
  });
  const navigate = useNavigate();

  const [criativo, setCriativo] = useState()
  const [loading, setLoading] = useState(true)
  const [files, setFiles] = useState([])
  const [abrirModalFinalizar, setAbrirModalFinalizar] = useState(false)
  const [abrirModalReabrir, setAbrirModalReabrir] = useState(false)
  const [criativoFechado, setCriativoFechado] = useState(false)
  const [ativarPontos, setAtivarPontos] = useState(false)
  const [desabilitarPontos, setDesabilitarPontos] = useState(true)

  const buscarCriativo = () => {
    setLoading(true)
    api.get(`/criativo/${id}`).then((response) => {
      const responseDados = response.data.data.criativo
      setCriativo(responseDados)
      if (responseDados.aparecerPontos) {
        setAtivarPontos(true)
      }
      reset({
        prazo_estimado: responseDados.prazo_estimado,
        pontos: responseDados.pontos
      })
      setLoading(false)
    }).catch((error) => {
      console.log(error)
      toast.error("Erro ao buscar criativo")
    })
  }

  const onSubmitFunction = async () => {
    const formValues = getValues();
    formValues.criativo_id = id
    setLoading(true)

    if (
      formValues.prazo_estimado &&
      new Date(formValues.prazo_estimado) < new Date(criativo.prazo_estimado)
    ) {
      setLoading(false)
      return toast.error("Prazo estimado menor que o atual")
    }

    const response = await api.post(`/criativo-mensagem/`, { criativoMensagens: [formValues] })
      .then((response) => {
        return response
      })
      .catch((error) => {
        toast.error(error.response.data.message);
      });

    const idCriativoMensagem = response.data.data.insertId;

    if (criativo.prazo_estimado != formValues.prazo_estimado || criativo.pontos != formValues.pontos) {
      await api.patch(`/criativo/${criativo.id}`, { prazo_estimado: formValues.prazo_estimado, pontos: formValues.pontos })
        .then((response) => {
        })
        .catch((error) => {
          toast.error(error.response.data.message);
        });
    }

    if (files) {
      const formData = new FormData();
      files.forEach((arquivo, index) => {
        formData.append(`arquivo_campanha_${idCriativoMensagem}`, arquivo);
      });

      try {
        await api.post(`/criatio-mensagem-anexo/${idCriativoMensagem}/`, formData);
        reset()
        setFiles([])
        buscarCriativo()
        toast.success("Item atualizado com sucesso!");
      } catch {
        toast.error("Erro ao enviar o arquivo, por favor tente novamente");
        reset()
        setFiles([])
        buscarCriativo()
      }
    } else {
      reset()
      setFiles([])
      buscarCriativo()
      toast.success("Item atualizado com sucesso!");
    }

    setLoading(false)
  };

  function removerArquivo(index) {
    const novaListaArquivos = [...files];
    novaListaArquivos.splice(index, 1);
    setFiles(novaListaArquivos);
  }

  useEffect(() => {
    buscarCriativo()
  }, [id]);

  useEffect(() => {
    if (criativo) {
      setCriativoFechado(criativo.status === "finalizado" ? true : false)
    }
  }, [criativo])

  return (
    <NovoUsuarioContainer >
      <div className="box">
        <div className="flex">
          <ReactSVG
            onClick={() => navigate("/criativo")}
            className="voltar"
            src={voltar}
          />
          <div>
            <div className="titulo">
              <ReactSVG src={Criativo} />
              <div className="column">
                <h1>Criativo {id}</h1>
                <span className="underline">{criativo?.titulo}</span>
              </div>
            </div>
          </div>
        </div>
        {
          loading ?
            <Loading />
            :
            <Body onSubmit={handleSubmit(onSubmitFunction)}>
              {
                criativoFechado ?
                  <div className="div-finalizada">
                    <div className="status-finalizado">
                      <span>finalizado</span>
                    </div>
                    <div className="column">
                      <div>
                        <h4 className="info-pedido">Pedido finalizado em {criativo.data_atualizacao} por Administrador</h4>
                        <h5 className="justificativa">{criativo.justificativa}</h5>
                      </div>
                    </div>
                  </div>
                  :
                  <>
                    <ContainerInputs>
                      <div>
                        <label>Tipo *</label>
                        <select {...register("tipo")} disabled={criativoFechado} onChange={(e) => {
                          if (e.target.value === "Debriefing") {
                            setDesabilitarPontos(false)
                          } else {
                            setDesabilitarPontos(true)
                            setValue("pontos", criativo.pontos)
                          }

                          if (e.target.value === "Debriefing" || criativo.aparecerPontos) {
                            setAtivarPontos(true)
                          } else {
                            setAtivarPontos(false)
                          }
                        }}>
                          <option value={""} >Selecionar tipo</option>
                          {user && user.perfil.includes("administrador") ?
                            <>
                              <option>Alinhamento de Necessidade</option>
                              <option>Debriefing</option>
                              <option>Entrega de V1</option>
                              <option>Entrega de V2</option>
                              <option>Entrega de V3</option>
                              <option>Entrega de V4</option>
                              <option>Entrega de V5</option>
                              <option>Entrega de V6</option>
                              <option>Briefing</option>
                              <option>Pedido de Alteração</option>
                              <option>Refação</option>
                              <option>Aprovação</option>
                            </>
                            :
                            user && ["administrador", "atendimento", "produtor", "compras"].includes(user?.perfil) ?
                              <>
                                <option>Alinhamento de Necessidade</option>
                                <option>Debriefing</option>
                                <option>Entrega de V1</option>
                                <option>Entrega de V2</option>
                                <option>Entrega de V3</option>
                                <option>Entrega de V4</option>
                                <option>Entrega de V5</option>
                                <option>Entrega de V6</option>
                              </>
                              :
                              <>
                                <option>Alinhamento de Necessidade</option>
                                <option>Briefing</option>
                                <option>Pedido de Alteração</option>
                                <option>Refação</option>
                                <option>Aprovação</option>
                              </>
                          }
                        </select>
                        {errors.tipo && (
                          <span className="input-error-cadastro">
                            {errors.tipo.message}
                          </span>
                        )}
                      </div>
                      {
                        ativarPontos ?
                          <>
                            <div className="div-pontos">
                              <label>Pontos</label>
                              <input disabled={criativoFechado || user.perfil == "cliente" || desabilitarPontos} {...register("pontos")} type="number" min={0} max={999} onChange={(e) => {
                                let value = parseInt(e.target.value, 10);

                                if (isNaN(value)) {
                                  e.target.value = "";
                                  return;
                                }

                                if (value < 0) value = 0;
                                if (value > 999) value = 999;

                                e.target.value = value;
                              }} />
                            </div>
                          </>
                          :
                          <></>
                      }
                      {
                        ["administrador", "atendimento", "produtor", "compras"].includes(user?.perfil) &&
                        <div className="prazo">
                          <label>Prazo Estimado</label>
                          <input {...register("prazo_estimado")} type="date" disabled={criativoFechado} />
                        </div>
                      }
                    </ContainerInputs>
                    <ContainerInputs>
                      <div>
                        <label>Comentário *</label>
                        <textarea
                          type="text"
                          name="comentario"
                          {...register("comentario")}
                          placeholder="Título do criativo"
                          disabled={criativoFechado}
                        />
                        {errors.comentario && (
                          <span className="input-error-cadastro">
                            {errors.comentario.message}
                          </span>
                        )}
                      </div>
                    </ContainerInputs>
                    <ContainerInputs>
                      <div>
                        <label>Anexos</label>
                        <input
                          {...register("file")}
                          type="file"
                          id="file"
                          multiple={true}
                          accept="image/*, application/pdf,text/plain"
                          onChange={(e) => {
                            setFiles([...e.target.files, ...files]);
                          }}
                          hidden={true}
                        />
                        <label className='label-file' for={criativoFechado ? "" : "file"} disabled={criativoFechado}>Anexar arquivo
                        </label>
                      </div>
                    </ContainerInputs>
                    <div className="div-files">
                      {files.length > 0 &&
                        files.map((elem, outerIndex) => (
                          <div className="relative-file" key={outerIndex}>
                            <div>
                              {elem.type.startsWith("image/") ? (
                                <img src={URL.createObjectURL(elem)} alt="Arquivo Anexado" width={100} />
                              ) : (
                                <h5>{elem.name.slice(0, 30)}{elem.name.length > 30 ? "..." : ""}</h5>
                              )}
                              <span onClick={() => removerArquivo(outerIndex)}>X</span>
                            </div>
                          </div>
                        ))
                      }
                    </div>
                  </>
              }
              <div className="buttons">
                {!criativoFechado && <button type="submit" className="button" disabled={criativoFechado}>Adicionar</button>}
                {
                  ["administrador", "atendimento", "produtor", "compras"].includes(user?.perfil) && criativo.status === "em andamento" &&
                  <span onClick={() => setAbrirModalFinalizar(true)} className="finalizar">Finalizar criativo</span>
                }
                {
                  ["administrador", "atendimento", "produtor", "compras"].includes(user?.perfil) && criativo.status === "finalizado" &&
                  <span onClick={() => setAbrirModalReabrir(true)} className="finalizar">Reabrir criativo</span>
                }
              </div>
              <h2 className="titulo2">
                <ReactSVG src={Historico} />
                Histórico
              </h2>
              <Table mensagens={criativo.mensagens} buscarCriativo={buscarCriativo} />
            </Body>
        }
      </div>
      {
        abrirModalFinalizar &&
        <ModalFinalizarCriativo state={setAbrirModalFinalizar} criativo={criativo} buscarCriativo={buscarCriativo} />
      }
      {
        abrirModalReabrir &&
        <ModalReabrirCriativo state={setAbrirModalReabrir} criativo={criativo} buscarCriativo={buscarCriativo} />
      }
    </NovoUsuarioContainer >
  );
};

export default EditarCriativo;
